function Badge({ badgeStatus, badgeText, title }) {
  const status = "ml-2 badge " + badgeStatus + " text-white";
  return (
    <span className={`${status}`} title={title}>
      {" "}
      {badgeText}
    </span>
  );
}
export default Badge;
